module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin11.3ccd9ab.woff2";